import React, { useState, useEffect } from 'react';
import axios from 'axios';
import '../Css/Blog.css';
// 1. Import Helmet from react-helmet-async
import { Helmet } from 'react-helmet-async';



function DSBlog() {
    const [htmlContent, setHtmlContent] = useState('');

    useEffect(() => {
        const fetchData = async () => {
            const formData = new FormData();
            const url = "https://homerepairexperthk.com/displayMessage.php";
            try {
                const response = await axios.post(url, formData, { responseType: 'text' });
                // 确保拿到字符串
                let rawHtml = response.data;
                // 如果 response.data 是 JSON 字符串，尝试解析
                if (typeof rawHtml === 'string' && rawHtml.trim().startsWith('{')) {
                    try {
                        const parsed = JSON.parse(rawHtml);
                        rawHtml = parsed.content || rawHtml;
                    } catch (e) {
                        // 不是 JSON，保留原字符串
                    }
                }
                setHtmlContent(rawHtml);
                console.log("HTML 长度:", rawHtml.length);
            } catch (error) {
                console.error("请求失败:", error);
            }
        };
        fetchData();
    }, []);

    const extractArticleContent = (htmlString) => {
        if (!htmlString || typeof htmlString !== 'string') return '';
        try {
            const parser = new DOMParser();
            const doc = parser.parseFromString(htmlString, 'text/html');
            const article = doc.querySelector('article');
            return article ? article.outerHTML : htmlString;
        } catch (err) {
            console.warn("解析 HTML 失败:", err);
            return htmlString;
        }
    };

    const contentToRender = extractArticleContent(htmlContent);

    return (
        <div>
            <Helmet>
                <title>家居維修貼士與 DIY 教學 | 維修王：水電冷氣維修百科</title>
                <meta name="description" content="維修王每週更新家居維修文章，分享牆身滲水、跳掣、冷氣漏水等處理方法。提升你的家居維修常識，助你初步診斷疑難點。" /> 
                <meta property="og:title" content="家居維修百科：實用 DIY 貼士與師傅不傳之秘" />
                <meta property="og:description" content="了解更多家居維修技巧，減少損耗，延長家具壽命。專業知識盡在維修王博客。" />
                <meta property="og:image" content="https://homerepairexperthk.com" />
                <meta property="og:url" content="https://homerepairexperthk.com" />
            </Helmet>
            
            <div className="Course-Wrapper">
            <div className="Course-Content">
                <div
                    className="Course-Body"
                    dangerouslySetInnerHTML={{ __html: contentToRender }}
                />
            </div>
            </div>
        </div>
    );
}

export default DSBlog;